export default __webpack_public_path__ + "static/media/5-Inam-Hvor og når føler du deg mest fremmed.9849fb83.mp4";